<template>
  <div>
    <van-popup
      class="full-width full-height"
      v-model="isShow"
      position="right"
      :close-on-popstate="true"
    >
      <div>
        <ld-header @click-left="toggle">
          {{ title }}
        </ld-header>

        <van-tabs
          v-model="active"
          :line-height="3"
          @change="init"
        >
          <van-tab title="大巴">
            <div
              @click="getDetail(airport.id)"
              v-for="(airport,i) in orderlist"
              :key="i"
            >
              <van-cell-group>
                <van-cell class="font14">
                  <div class="font16">
                    <ld-icon
                      class="icon main-color"
                      type="iconjh_gjc_dt"
                    />
                    {{ airport.trfTypeName }}
                    <span class="fr red">￥{{ airport.trfPrice }}</span>
                  </div>
                  <ld-icon
                    class="icon main-color"
                    type="iconjichang"
                  />
                  {{ airport.terminal }}({{ airport.trfStation }})出发
                  <div class="gray font12">
                    {{ airport.trfTime }}
                  </div>
                </van-cell>
              </van-cell-group>
            </div>
          </van-tab>
          <van-tab title="地铁">
            <div
              @click="getDetail(airport.id)"
              v-for="(airport,i) in orderlist"
              :key="i"
            >
              <van-cell-group>
                <van-cell class="font14">
                  <div class="font16">
                    <ld-icon
                      class="icon main-color"
                      type="iconjh_gjc_dt"
                    />
                    {{ airport.trfTypeName }}
                    <span class="fr red">￥{{ airport.trfPrice }}</span>
                  </div>
                  <ld-icon
                    class="icon main-color"
                    type="iconjichang"
                  />
                  {{ airport.terminal }}({{ airport.trfStation }})出发
                  <div class="gray font12">
                    {{ airport.trfTime }}
                  </div>
                </van-cell>
              </van-cell-group>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <ld-no-more />
      <!--  -->
      <van-popup
        class="full-width"
        v-model="isShowBus"
        :close-on-popstate="true"
      >
        <van-cell class="font16">
          {{ detail.trfTypeName }}  ({{ detail.trfMode }})
        </van-cell>
        <van-cell title="票价">
          <span class="red">&yen;{{ detail.trfPrice }}</span>
        </van-cell>
        <van-cell
          title="运营时间"
          :label="detail.trfTime"
        />
        <van-cell
          title="行驶路线"
          :label="detail.trfRoute"
        />
        <van-cell title="咨询电话">
          {{ detail.trfTel }}
        </van-cell>
      </van-popup>
    <!--  -->
    </van-popup>
  </div>
</template>
<script>
import {Popup ,Tab, Tabs ,Icon,Cell,CellGroup,Panel} from 'vant'
import ldHeader from 'Common/ldHeader'
import ldNoMore from 'Common/ldNoMore'

export default {
  name:'Taxi',
  data() {
    return {
      isShow:false,
      isShowBus:false,
      active: '1', //   1 大巴 2 地铁
      orderlist: [],
      detail: {},
    }
  },
  components:{
    [Popup.name]:Popup,
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Icon.name]:Icon,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Panel.name]:Panel,
    ldHeader,
    ldNoMore
  },
  props:{
    title:{
      type:String,
      default:''
    },
    threeCode:{//三字码
      type:String,
      default:''
    },
    terminal:{//航站楼
      type:String,
      default:'T1'
    }
  },
  computed:{
  },
  methods:{
    init(){
      this.getCarList()
    },
    getCarList() {
      this.$api['tkStrategy/queryApTrfInfo']({
        threeCode: this.threeCode,
        trfType: this.active,
        terminal: this.terminal,
      }).then(resp=>{
        var respose = resp.data||{}
        this.orderlist = respose[this.active]
      })
    },
    getDetail(id){
      this.$api['tkStrategy/queryApTrfDetail']({
        id:id
      }).then(resp=>{
        var respose = resp.data||{}
        this.detail = respose
        this.isShowBus=true
      })
    },
    toggle(){
      this.isShow=!this.isShow
      if(this.isShow){
        this.init()
      }
    },
  }
}
</script>
<style lang="less" scoped>
    .pad-lr-16{
        padding:0 16px;
    }
    .icon{
        margin-right: 5px;
        min-width: 1em;
        height: 24px;
        font-size: 16px;
        line-height: 24px;
    }
</style>